import React, { useState, useEffect } from 'react';
import { FlatList, SafeAreaView, StyleSheet, View, Image } from 'react-native';
import CustomText from '../customText/CustomText';
import MessageListItem from './MessageListItem';
import { MainButton } from '../buttons/MainButton';
import theme from '../../constants/theme.style.js';

const loginTurtle = require('../../assets/Turtles/main-turtle.png');

const styles = StyleSheet.create({
  noMessagesContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.WHITE_COLOR,
    width: '100%',
    height: '100%',
    padding: theme.CONTAINER_MARGIN,
  },
  noMessagesText: {
    margin: theme.CONTAINER_MARGIN,
    textAlign: 'center',
    marginBottom: theme.CONTAINER_MARGIN * 4,
  },
  turtleTop: {
    width: '30%',
    height: 120,
  },
  messageList: {
    flex: 1,
  },
  safeAreaView: {
    flex: 1,
    height: '130%',
  },
});

const MessageList = ({
  navigation,
  onMessageDisplay,
  onOutboxDisplay,
  onMessagePress,
  currentUser,
  inbox,
  outbox,
  isInbox = true,
}) => {
  useEffect(() => {
    onMessageDisplay(currentUser.user.id);
    onOutboxDisplay(currentUser.user.id);
  }, []);

  const messages = isInbox ? inbox : outbox;
  const [refreshing, setRefreshing] = useState(false);

  function handleRefresh() {
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    setRefreshing(true);
    onMessageDisplay(currentUser.user.id);
    onOutboxDisplay(currentUser.user.id);
    wait(500)
      .then(() => setRefreshing(false))
      .catch(() => {
        // error -> do nothing
      });
  }

  if (messages.length === 0) {
    return (
      <View style={styles.noMessagesContainer}>
        <Image style={styles.turtleTop} source={loginTurtle} resizeMode="contain" />
        <CustomText testID="nomessages" style={styles.noMessagesText}>
          No messages yet.
          {'\n'}
          Start your journey by adding friends and writing letters to them.
        </CustomText>
        <MainButton
          title="Refresh List"
          btnBgColor={theme.GREEN_DARKER_COLOR}
          textColor="#FFFFFF"
          btnTextSize={15}
          btnWidth={200}
          btnPadding="5%"
          btnPress={() => handleRefresh()}
          testID="refreshButton"
        />
      </View>
    );
  }
  return (
    <SafeAreaView style={styles.safeAreaView}>
      <FlatList
        data={messages}
        style={styles.messageList}
        refreshing={refreshing}
        onRefresh={handleRefresh}
        renderItem={({ item }) => (
          <MessageListItem
            id={item.id.toString()}
            sender={item.sender}
            recipient={item.recipient}
            title={`${item.text.substring(0, 20).replace(/\n|\r/g, ' ')}…`}
            text={item.text}
            read={item.read}
            date={item.deliverAt}
            navigation={navigation}
            onMessagePress={onMessagePress}
            onMessageDisplay={onMessageDisplay}
            userId={currentUser.user.id}
            isInbox={isInbox}
          />
        )}
        keyExtractor={(item) => item.id.toString()}
        extraData={false}
        testID="myMessageList"
        ListFooterComponent={<View style={{ width: '100%', height: 100 }} />}
      />
    </SafeAreaView>
  );
};

export default MessageList;
